import React, { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { STICKY_CTA } from "@/constants/testIds";
import { INTAKE_URL } from "@/constants/links";

// Distance (in pixels) scrolled before the sticky CTA bar appears.
const SCROLL_THRESHOLD_PX = 600;

export default function StickyCta() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > SCROLL_THRESHOLD_PX);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only listener; setShow is stable
  }, []);

  if (!show) return null;

  return (
    <div
      data-testid={STICKY_CTA.root}
      className="iw-cta-bar fixed inset-x-0 bottom-0 z-30 hidden lg:block"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-6 px-8 py-3">
        <a
          href={INTAKE_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={STICKY_CTA.apply}
          className="iw-btn-red ml-auto inline-flex items-center gap-2 px-6 py-3 font-mono text-[12px] uppercase tracking-[0.22em] sm:text-[13px]"
        >
          Get Started <ArrowUpRight className="h-4 w-4" />
        </a>
      </div>
    </div>
  );
}
